import { LeagueFieldBaseValue } from './league-field-base-value';
import { ModelInstance, ToBackHook, ToFrontHook } from './util';
import { File } from './file';
import { LeagueTeamField } from './league-team-field';

@ModelInstance({
  mappingFields: {
    id: 'id',
    league_team_field_id: 'leagueTeamFieldId',
    league_team_field: 'leagueTeamField',
    value: 'value',
    file: 'file',
    value_text: 'valueText',
  },
  relation: {
    file: File,
    leagueTeamField: LeagueTeamField,
  }
})
export class TournamentTeamFieldValue extends LeagueFieldBaseValue {
  leagueTeamFieldId: number;
  leagueTeamField: LeagueTeamField;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
